import { createFileRoute, redirect } from '@tanstack/react-router';
import { AppRoute } from '@agentselly/immodossier-shared';

export const Route = createFileRoute('/valiant')({
  beforeLoad: () => {
    throw redirect({
      to: AppRoute.$LANG_$COMPANYID_PUBLIC_AUTH_LOGIN as any,
      replace: true,
      params: {
        lang: 'de',
        companyId: '145859503298',
      },
    });
  },
  component: () => null,
});
